import {
  SessionType,
  updateRoleAndScreen,
  addStatusMessage,
  setSessionType,
  ConnectionStatus,
  setConnectionStatus,
} from '../redux/reducers';
import { publishLocalVideoTrack, unpublishVideoTracks } from './twilio';

const findTrack = (publications, name) => {
  for (const [, publication] of publications) {
    if (!publication.track) {
      continue;
    }
    if (publication.track.name === name) {
      return publication.track;
    }
  }
};

const getAdminTrack = (getState, cmd) => {
  const { room } = getState().twilio;
  if (!room) {
    console.warn(`adminCmd ${cmd} failed: no room`);
    return;
  }

  const adminTrack = findTrack(room.localParticipant.dataTracks, 'admin');
  if (!adminTrack) {
    console.warn(`adminCmd ${cmd} failed: no track`);
    return;
  }

  return adminTrack;
};

const changeParticipantRole = (name, role) => (dispatch, getState) => {
  const adminTrack = getAdminTrack(getState, 'CHANGE_ROLE');
  if (adminTrack) {
    // console.log('send changeRole', name, role);
    const command = { action: 'CHANGE_ROLE', name, role };
    adminTrack.send(JSON.stringify(command));
  }
};

const kickParticipant = (name) => (dispatch, getState) => {
  const adminTrack = getAdminTrack(getState, 'KICK');
  if (adminTrack) {
    const command = { action: 'KICK', name };
    adminTrack.send(JSON.stringify(command));
  }
};

const muteParticipant = (name) => (dispatch, getState) => {
  const adminTrack = getAdminTrack(getState, 'MUTE');
  if (adminTrack) {
    const command = { action: 'MUTE', name };
    adminTrack.send(JSON.stringify(command));
  }
};

const changeSessionType = (type) => (dispatch, getState) => {
  const adminTrack = getAdminTrack(getState, 'CHANGE_TYPE');
  if (adminTrack) {
    const command = { action: 'CHANGE_TYPE', type };
    adminTrack.send(JSON.stringify(command));
  }
};

export const AdminCommands = {
  changeParticipantRole,
  kickParticipant,
  muteParticipant,
  changeSessionType,
};

export const handleAdminMessage = (message) => (dispatch, getState) => {
  try {
    const command = JSON.parse(message);
    if (command.action === 'CHANGE_ROLE') {
      const { name, role } = command;
      dispatch(updateRoleAndScreen(name, role));
    } else if (command.action === 'KICK') {
      const { name } = command;
      dispatch(addStatusMessage('chat.kicked', { name }));
      const { room } = getState().twilio;
      if (name === room.localParticipant.identity) {
        dispatch(setConnectionStatus(ConnectionStatus.KICKED));
      }
    } else if (command.action === 'MUTE') {
      const { name } = command;
      const self = getState().activeSession.members.find((m) => m.isSelf);
      if (name === (self && self.name)) {
        const localAudio = getState().twilio.audioTrack;
        localAudio.disable();
        dispatch(addStatusMessage('chat.youMuted', { name }));
      }
    } else if (command.action === 'CHANGE_TYPE') {
      const { type } = command;
      dispatch((dispatch, getState) => {
        const oldType = getState().activeSession.type;
        dispatch(setSessionType(type));
        if (oldType === SessionType.VIDEO && type === SessionType.TEXT) {
          dispatch(unpublishVideoTracks());
        } else if (oldType === SessionType.TEXT && type === SessionType.VIDEO) {
          const { cameraInUse } = getState().settings;
          dispatch(publishLocalVideoTrack(cameraInUse));
        }
      });
    } else {
      console.log('Unknown chat command', command);
    }
  } catch (error) {
    console.error('chat command failed:', error);
  }
};
